import { defineStore } from 'pinia'
import { UserStore } from '@/front/stores/user_store.js'

export const UploadStore = defineStore('uploads', {
  state: () => {
    return {
      uploadProgress: 0,
      isUploading: false,
      videoToReplace: null,
      uploadFile: null,
      uploadSource: {
        src: null,
        type: null,
        temporary: true,
      },
      uploadSettings: {
        title: '',
        key: '',
        type_of: '',
        size: 0,
        duration: 0,
        transcode: true,
        transcribe: true,
        vimeo_id: null,
        wistia_id: null,
        youtube_id: null,
        loom_id: null,
        heygen_id: null,
        synthesia_id: null,
        kaltura_id: null,
        panopto_id: null,
        storyboard_url: null,
        storyboard_frame_width: null,
        storyboard_frame_height: null,
        storyboard_frame_count: null,
        storyboard_ratio: null,
        aspect_ratio: 1.77,
        backup_url: null,
        thumbnail: null,
        group_id: null,
        stock_attribution: null,
      },
      pagination: {page: 1},
      fetchingSynthesiaVideos: false,
      synthesia_videos: [],
      fetchingHeygenVideos: false,
      heygen_videos: [],
      fetchingStockVideos: false,
      stock_videos: [],
      stock_search_query: '',
      stock_destination: 5, // Default to Pexels
    }
  },

  actions: {
    resetUploadSettingsAndFile(groupId = this.uploadSettings.group_id) {
      this.resetUploadSettings(groupId)
      this.uploadFile = null
      this.uploadSource = {
        src: null,
        type: null,
        temporary: true,
      }
    },
    resetUploadSettings(groupId = this.uploadSettings.group_id) {
      const effectiveGroupId = groupId ?? null
      this.uploadSettings = {
        title: '',
        key: '',
        type_of: '',
        size: 0,
        duration: 0,
        transcode: true,
        transcribe: true,
        vimeo_id: null,
        wistia_id: null,
        youtube_id: null,
        loom_id: null,
        heygen_id: null,
        synthesia_id: null,
        kaltura_id: null,
        panopto_id: null,
        storyboard_url: null,
        storyboard_frame_width: null,
        storyboard_frame_height: null,
        storyboard_frame_count: null,
        storyboard_ratio: null,
        aspect_ratio: 1.77,
        backup_url: null,
        thumbnail: null,
        group_id: effectiveGroupId,
        stock_attribution: null,
        bunnyVideoId: null,
        bunnyId: null,
      }
      // this.uploadFile = null
      // this.uploadSource = {
      //   src: null,
      //   type: null,
      //   temporary: true,
      // }
      log.info(1,"🌜 UploadStore resetUploadSettings")
    },

    getArgs() {
      return { 
        key: this.uploadSettings.key, 
        name: this.uploadFile?.name, 
        size: this.uploadFile?.size,
        title: this.uploadSettings.title,
        type_of: this.uploadSettings.type_of,
        transcode: this.uploadSettings.transcode,
        transcribe: this.uploadSettings.transcribe,
        vimeo_id: this.uploadSettings.vimeo_id,
        wistia_id: this.uploadSettings.wistia_id,
        duration: this.uploadSettings.duration,
        thumbnail: this.uploadSettings.thumbnail,
        group_id: this.uploadSettings.group_id,
        // youtube_id: this.uploadSettings.youtube_id,
        loom_id: this.uploadSettings.loom_id,
        heygen_id: this.uploadSettings.heygen_id,
        google_drive_id: this.uploadSettings.google_drive_id,
        synthesia_id: this.uploadSettings.synthesia_id,
        // kaltura_id: this.uploadSettings.kaltura_id,
        panopto_id: this.uploadSettings.panopto_id,
        storyboard_url: this.uploadSettings.storyboard_url,
        storyboard_frame_width: this.uploadSettings.storyboard_frame_width,
        storyboard_frame_height: this.uploadSettings.storyboard_frame_height,
        storyboard_frame_count: this.uploadSettings.storyboard_frame_count,
        backup_url: this.uploadSettings.backup_url,
        aspect_ratio: this.uploadSettings.aspect_ratio,
        // Add Bunny-specific fields
        bunny_id: this.uploadSettings.bunnyId,
      }
    },

    async replaceVideo() {
      const args = this.getArgs()
      log.info(1,"🌜 UploadStore replaceVideo", args)
      return this.Api.post(`/videos/${this.videoToReplace.id}/replace`, args).then(response => {  
        this.setUploadSource()
        log.info(1,"UploadSource", this.uploadSource)
        // Reset upload settings after successful replace to prevent stale data
        // this.resetUploadSettings()
        return response.data.video
      })
    },

    async createVideo() {
      const userStore = UserStore()
      const args = this.getArgs()
      log.info(1,"🌜 UploadStore createVideo", args)
      return this.Api.post('/videos', args).then(response => {  
        this.video = response.data.video; 
        this.setUploadSource()
        if (userStore.user?.org_owner && userStore.organization?.plan == 'free') {
          userStore.refreshActivation()
        }
        log.info(1,"UploadSource", this.uploadSource)
        // Reset upload settings after successful create to prevent stale data
        // this.resetUploadSettings()
      }).finally(() => {
        this.loading = false
      })
    },

    setUploadSource() {
      log.info(1,"SetUploadSource", this.uploadFile)
      if (this.uploadFile) {
        this.uploadSource = {
          src: URL.createObjectURL(this.uploadFile),
          type: this.uploadFile.type,
          temporary: true
        } 
      } else {
        this.uploadSource = false
      }
    },

    async checkLink(link) {
      link = encodeURIComponent(link)
      return this.Api.get(`/links/check_link?link=${link}`).then(response => {
        return response.data.valid
      })
    },

    async getWistiaAssets(wistia_id) {
      return this.Api.get(`/links/get_wistia_assets?id=${wistia_id}`).then(response => {
        return response
      })
    },

    async getLoomMP4(loom_id) {
      return this.Api.get(`/links/get_loom_mp4?id=${loom_id}`).then(response => {
        return response
      })
    },

    async getPanoptoMP4(url) {
      log.info(1,"🌜 UploadStore getPanoptoMP4", url)
      return this.Api.get(`/links/get_panopto_mp4?url=${url}`).then(response => {
        return response
      })
    },

    async getJWPlayerMP4(url) {
      log.info(1,"🌜 UploadStore getJWPlayerMP4", url)
      return this.Api.get(`/links/get_jwplayer_mp4?url=${url}`).then(response => {
        return response
      })
    },

    async getKalturaMP4(url) {
      return this.Api.get(`/links/get_kaltura_mp4?url=${url}`).then(response => {
        return response
      })
    },

    async getSynthesiaVideos(token='') {
      this.fetchingSynthesiaVideos = true
      return this.Api.get(`/synthesia_videos?token=${token}`).then(response => {
        log.info(1,"🌜 UploadStore getSynthesiaVideos", response)
        if (response.data.connected) {
          this.synthesia_videos = response.data.videos
        }
      }).catch(error => {
        log.info(1,"🌜 UploadStore getSynthesiaVideos", error)
      }).finally(() => {
        this.fetchingSynthesiaVideos = false
      })
    },

    async createSampleVideo() {
      const userStore = UserStore()
      return this.Api.post('/videos/create_sample').then(response => {
        if (userStore.user?.org_owner && userStore.organization?.plan == 'free') {
          userStore.refreshActivation()
        }
        return response
      })
    },

    async getHeygenVideos(token='') {
      this.fetchingHeygenVideos = true
      return this.Api.get(`/heygen_videos?token=${token}`).then(response => {
        log.info(1,"🌜 UploadStore getHeygenVideos", response)
        if (response.data.connected) {
          this.heygen_videos = response.data.videos
        } 
        return { connected: response.data.connected }
      }).catch(error => {
        log.info(1,"🌜 UploadStore getHeygenVideos", error)
      }).finally(() => {
        this.fetchingHeygenVideos = false
      })
    },

    async searchStockVideos(query, destination, page = 1) {
      log.info(1,"🌜 UploadStore searchStockVideos", query, destination, page)
      this.fetchingStockVideos = true
      this.stock_search_query = query
      this.stock_destination = destination
      
      return this.Api.get(`/stocks/search?query=${query}&destination=${destination}&type=video&page=${page}`).then(response => {
        log.info(1,"🌜 UploadStore searchStockVideos", response)
        const results = response.data.results || []
        
        // For page 1, replace all videos. For subsequent pages, append
        if (page === 1) {
          this.stock_videos = results
        } else {
          // Append new results, avoiding duplicates
          const existingIds = new Set(this.stock_videos.map(v => v.id))
          const newVideos = results.filter(v => !existingIds.has(v.id))
          this.stock_videos = [...this.stock_videos, ...newVideos]
        }
        
        return response.data
      }).catch(error => {
        log.info(1,"🌜 UploadStore searchStockVideos error", error)
        if (page === 1) {
          this.stock_videos = []
        }
        throw error
      }).finally(() => {
        this.fetchingStockVideos = false
      })
    },

    async getPopularStockVideos(destination = 'pexels', page = 1) {
      log.info(1,"🌜 UploadStore getPopularStockVideos", destination, page)
      this.fetchingStockVideos = false
      this.stock_destination = destination
      
      return this.Api.get(`/stocks/popular?destination=${destination}&page=${page}`).then(response => {
        log.info(1,"🌜 UploadStore getPopularStockVideos", response)
        const results = response.data.results || []
        
        // For page 1, replace all videos. For subsequent pages, append
        if (page === 1) {
          this.stock_videos = results
        } else {
          // Append new results, avoiding duplicates
          const existingIds = new Set(this.stock_videos.map(v => v.id))
          const newVideos = results.filter(v => !existingIds.has(v.id))
          this.stock_videos = [...this.stock_videos, ...newVideos]
        }
        
        return response.data
      }).catch(error => {
        log.info(1,"🌜 UploadStore getPopularStockVideos error", error)
        if (page === 1) {
          this.stock_videos = []
        }
        throw error
      }).finally(() => {
        this.fetchingStockVideos = false
      })
    },
  }
})
